import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/screen/inquiry/list/index.tsx");
